import React from 'react'
import PropTypes from 'prop-types'
import Form from 'pages/widgets/form-actions/edit'
import PageTemplate from 'components/page-template'

export class EditMosaicPage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showMosaicDeployModal: false
    }

    this.handleShowMosaicDeployModal = this.handleShowMosaicDeployModal.bind(
      this
    )
    this.handleHideMosaicDeployModal = this.handleHideMosaicDeployModal.bind(
      this
    )
  }

  handleShowMosaicDeployModal () {
    this.setState({ showMosaicDeployModal: true })
  }

  handleHideMosaicDeployModal () {
    this.setState({ showMosaicDeployModal: false })
  }

  render () {
    return (
      <PageTemplate
        title='Update a Photo Mosaic Experience'
        description="that's where automagic happens"
        className='br-experience widgetBuilder'
      >
        <Form
          id={this.props.params.id}
          experiencePlatform='twitter'
          handleHideMosaicDeployModal={this.handleHideMosaicDeployModal}
          handleShowMosaicDeployModal={this.handleShowMosaicDeployModal}
          showMosaicDeployModal={this.state.showMosaicDeployModal}
        />
      </PageTemplate>
    )
  }
}

EditMosaicPage.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string })
}

export default EditMosaicPage



// WEBPACK FOOTER //
// ./src/pages/widgets/mosaic/edit/index.js